// 자주 사용되는 그라데이션 프리셋 정의
export const gradientPresets = [
  // 기본 그라데이션
  {
    id: 'sunset',
    name: '일몰',
    gradient: 'linear-gradient(135deg, rgb(255, 107, 107) 0%, rgb(255, 230, 109) 100%)'
  },
  {
    id: 'ocean',
    name: '바다',
    gradient: 'linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)'
  },
  {
    id: 'forest',
    name: '숲',
    gradient: 'linear-gradient(135deg, rgb(17, 153, 142) 0%, rgb(56, 239, 125) 100%)'
  },
  {
    id: 'fire',
    name: '불꽃',
    gradient: 'linear-gradient(135deg, rgb(240, 147, 251) 0%, rgb(245, 87, 108) 100%)'
  },
  {
    id: 'sky',
    name: '하늘',
    gradient: 'linear-gradient(135deg, rgb(79, 172, 254) 0%, rgb(0, 242, 254) 100%)'
  },
  {
    id: 'peach',
    name: '복숭아',
    gradient: 'linear-gradient(135deg, rgb(255, 236, 210) 0%, rgb(252, 182, 159) 100%)'
  },
  
  // 비즈니스 톤
  {
    id: 'professional',
    name: '프로페셔널',
    gradient: 'linear-gradient(135deg, rgb(67, 67, 67) 0%, rgb(0, 0, 0) 100%)'
  },
  {
    id: 'corporate',
    name: '기업',
    gradient: 'linear-gradient(135deg, rgb(72, 85, 99) 0%, rgb(41, 50, 60) 100%)'
  },
  {
    id: 'elegant',
    name: '우아함',
    gradient: 'linear-gradient(135deg, rgb(189, 195, 199) 0%, rgb(44, 62, 80) 100%)'
  },
  
  // 밝은 톤
  {
    id: 'sunny',
    name: '햇살',
    gradient: 'linear-gradient(135deg, rgb(253, 219, 146) 0%, rgb(209, 253, 255) 100%)'
  },
  {
    id: 'candy',
    name: '사탕',
    gradient: 'linear-gradient(135deg, rgb(251, 194, 235) 0%, rgb(166, 193, 238) 100%)'
  },
  {
    id: 'spring',
    name: '봄',
    gradient: 'linear-gradient(135deg, rgb(168, 237, 234) 0%, rgb(254, 214, 227) 100%)'
  },
  
  // 어두운 톤
  {
    id: 'midnight',
    name: '자정',
    gradient: 'linear-gradient(135deg, rgb(35, 37, 38) 0%, rgb(65, 67, 69) 100%)'
  },
  {
    id: 'space',
    name: '우주',
    gradient: 'linear-gradient(135deg, rgb(15, 12, 41) 0%, rgb(48, 43, 99) 50%, rgb(36, 36, 62) 100%)'
  },
  {
    id: 'deep-sea',
    name: '심해',
    gradient: 'linear-gradient(135deg, rgb(5, 25, 55) 0%, rgb(0, 77, 122) 50%, rgb(0, 135, 147) 100%)'
  },
  
  // 특별한 효과
  {
    id: 'rainbow',
    name: '무지개',
    gradient: 'linear-gradient(135deg, rgb(255, 0, 0) 0%, rgb(255, 127, 0) 14%, rgb(255, 255, 0) 28%, rgb(0, 255, 0) 42%, rgb(0, 0, 255) 56%, rgb(75, 0, 130) 70%, rgb(148, 0, 211) 84%, rgb(255, 0, 0) 100%)'
  },
  {
    id: 'metallic',
    name: '금속',
    gradient: 'linear-gradient(135deg, rgb(173, 169, 150) 0%, rgb(242, 242, 242) 25%, rgb(219, 219, 219) 50%, rgb(234, 234, 234) 75%, rgb(242, 242, 242) 100%)'
  },
  {
    id: 'neon',
    name: '네온',
    gradient: 'linear-gradient(135deg, rgb(0, 255, 136) 0%, rgb(0, 180, 216) 50%, rgb(255, 0, 110) 100%)'
  },
  
  // 추가 예쁜 그라데이션들
  {
    id: 'instagram',
    name: '인스타그램',
    gradient: 'linear-gradient(45deg, rgb(64, 93, 230) 0%, rgb(91, 81, 216) 10%, rgb(131, 58, 180) 30%, rgb(193, 53, 132) 50%, rgb(225, 48, 108) 70%, rgb(253, 29, 29) 80%, rgb(245, 96, 64) 90%, rgb(247, 119, 55) 100%)'
  },
  {
    id: 'aurora',
    name: '오로라',
    gradient: 'linear-gradient(135deg, rgb(33, 147, 176) 0%, rgb(109, 213, 237) 33%, rgb(255, 255, 255) 66%, rgb(229, 45, 39) 100%)'
  },
  {
    id: 'lavender',
    name: '라벤더',
    gradient: 'linear-gradient(135deg, rgb(165, 142, 251) 0%, rgb(233, 191, 248) 100%)'
  },
  {
    id: 'mint',
    name: '민트',
    gradient: 'linear-gradient(135deg, rgb(76, 184, 196) 0%, rgb(60, 211, 173) 100%)'
  },
  {
    id: 'coral',
    name: '코랄',
    gradient: 'linear-gradient(135deg, rgb(255, 154, 158) 0%, rgb(250, 208, 196) 100%)'
  },
  {
    id: 'tropical',
    name: '트로피컬',
    gradient: 'linear-gradient(135deg, rgb(250, 112, 154) 0%, rgb(254, 225, 64) 100%)'
  },
  {
    id: 'galaxy',
    name: '은하수',
    gradient: 'linear-gradient(135deg, rgb(30, 19, 53) 0%, rgb(132, 59, 206) 35%, rgb(253, 29, 29) 70%, rgb(252, 176, 69) 100%)'
  },
  {
    id: 'cherry',
    name: '체리블라썸',
    gradient: 'linear-gradient(135deg, rgb(251, 211, 233) 0%, rgb(187, 55, 125) 100%)'
  },
  {
    id: 'aqua',
    name: '아쿠아',
    gradient: 'linear-gradient(135deg, rgb(26, 198, 255) 0%, rgb(53, 255, 202) 100%)'
  },
  {
    id: 'purple-dream',
    name: '퍼플드림',
    gradient: 'linear-gradient(135deg, rgb(123, 67, 151) 0%, rgb(220, 36, 48) 100%)'
  },
  {
    id: 'sunshine',
    name: '선샤인',
    gradient: 'linear-gradient(135deg, rgb(255, 231, 76) 0%, rgb(255, 144, 104) 100%)'
  },
  {
    id: 'deep-blue',
    name: '딥블루',
    gradient: 'linear-gradient(135deg, rgb(0, 4, 40) 0%, rgb(0, 78, 146) 100%)'
  },
  {
    id: 'pastel-pink',
    name: '파스텔핑크',
    gradient: 'linear-gradient(135deg, rgb(255, 175, 189) 0%, rgb(255, 195, 160) 100%)'
  },
  {
    id: 'emerald',
    name: '에메랄드',
    gradient: 'linear-gradient(135deg, rgb(2, 170, 176) 0%, rgb(0, 205, 172) 100%)'
  },
  {
    id: 'violet-sky',
    name: '보라빛하늘',
    gradient: 'linear-gradient(135deg, rgb(108, 92, 231) 0%, rgb(162, 155, 254) 100%)'
  },
  {
    id: 'flamingo',
    name: '플라밍고',
    gradient: 'linear-gradient(135deg, rgb(245, 112, 156) 0%, rgb(248, 177, 149) 100%)'
  },
  {
    id: 'midnight-city',
    name: '미드나잇시티',
    gradient: 'linear-gradient(135deg, rgb(35, 7, 77) 0%, rgb(204, 83, 51) 100%)'
  },
  {
    id: 'lime',
    name: '라임',
    gradient: 'linear-gradient(135deg, rgb(164, 255, 79) 0%, rgb(18, 225, 147) 100%)'
  },
  {
    id: 'rose-gold',
    name: '로즈골드',
    gradient: 'linear-gradient(135deg, rgb(233, 149, 149) 0%, rgb(254, 215, 183) 100%)'
  },
  {
    id: 'twilight',
    name: '황혼',
    gradient: 'linear-gradient(135deg, rgb(94, 58, 128) 0%, rgb(233, 89, 117) 50%, rgb(255, 225, 104) 100%)'
  }
];

// 방사형 그라데이션 프리셋
export const radialGradientPresets = [
  {
    id: 'spotlight',
    name: '스포트라이트',
    gradient: 'radial-gradient(circle, rgb(255, 255, 255) 0%, rgb(0, 0, 0) 100%)'
  },
  {
    id: 'glow',
    name: '광선',
    gradient: 'radial-gradient(circle, rgba(255, 239, 186, 1) 0%, rgba(255, 186, 73, 0) 70%)'
  },
  {
    id: 'halo',
    name: '헤일로',
    gradient: 'radial-gradient(circle, rgba(135, 206, 235, 1) 0%, rgba(30, 144, 255, 0) 80%)'
  },
  {
    id: 'sunset-circle',
    name: '원형일몰',
    gradient: 'radial-gradient(circle, rgb(255, 94, 77) 0%, rgb(255, 154, 0) 50%, rgb(237, 117, 23) 100%)'
  },
  {
    id: 'purple-glow',
    name: '퍼플글로우',
    gradient: 'radial-gradient(circle, rgb(162, 129, 255) 0%, rgba(162, 129, 255, 0) 70%)'
  },
  {
    id: 'neon-center',
    name: '네온센터',
    gradient: 'radial-gradient(circle, rgb(255, 0, 255) 0%, rgb(0, 255, 255) 50%, rgba(0, 0, 0, 0) 100%)'
  },
  {
    id: 'golden-sun',
    name: '골든썬',
    gradient: 'radial-gradient(circle, rgb(255, 223, 0) 0%, rgb(255, 191, 0) 50%, rgba(255, 128, 0, 0) 100%)'
  }
];

// 모든 프리셋 합치기
export const allGradientPresets = [...gradientPresets, ...radialGradientPresets];